import React from 'react';


function BlueTicket(props) {


return (
  <>
          <header class="header_section">
            <div class="header_discuss-bg reply">
              <div class="header_main container">
                <div data-v-47877036="" class="avatar">
                  <span data-v-47877036="" class="connect-text">آفلاین</span>
                  <span data-v-47877036="" class="connect" style={{ borderColor: "white" }}></span>
                  <div data-v-47877036="" class="image" style={{ borderColor: "rgb(180, 180, 180)" }}>
                    <a data-v-47877036="" href="/@khanzadimahdi">
                      <img data-v-47877036="" src="/public/images/useravatar/2019/12/17/1576578900.png" alt="user-avatar" />
                    </a>
                  </div>
                </div>
                <div class="details-discuss">
                  <h1 class="title">ترک دانشگاه و تحصیل به منظور برنامه نویسی و کار</h1>
                  <div class="details-list">
                    <div class="category">
                      <a href="https://roocket.ir/discuss/tagged/%D8%B9%D9%85%D9%88%D9%85%DB%8C">عمومی</a>
                    </div>
                    <div class="time-ago">۳ دقیقه پیش</div>
                    <div class="update"> توسط
                                       <a href="/@hadadi.ebi" class="user">Ebrahim Hadadi</a> آپدیت شد</div></div></div></div></div>
          </header>
  </>
) 
}

export default BlueTicket;